import { useState, useCallback } from "react";
import axios from "axios";
import moment from "moment";
import cSharpApi from "../../../../../../services/api/CSharpApi";
import { CurrentData, CurrentDataState } from "../../../SimpleAppTemplate";

interface CurrentBatteryData extends CurrentData {
  hasMaxBattery: boolean;
  hasMinBattery: boolean;
}

interface CurrentBatteryDataState extends CurrentDataState {
  data: CurrentBatteryData;
}

type FetchParams = {
  name: string;
  fieldKey: string;
  maximumBattery: number;
  minimumBattery: number;
  hoursToAdd: number;

  displayName?: string;
  fieldName?: string;
  orgId?: string;
};

const INITIAL_STATE = {
  data: {
    currentData: {
      time: moment(),
      value: 0,
      valueDisplayUnit: "",
    },
    hasData: false,
    hasMaxBattery: false,
    hasMinBattery: false,
    errorMessage: "",
  },
  isLoading: false,
  hasError: false,
  errorMessage: "",
  message: "",
};

const useCurrentBatCharge = (deviceId: string) => {
  // @ts-expect-error
  const [fetchedData, setFetchedData] = useState<CurrentBatteryDataState>(INITIAL_STATE);

  const cancelTokenSource = axios.CancelToken.source();

  const fetchData = useCallback(
    async (params: FetchParams) => {
      // @ts-expect-error
      setFetchedData({
        ...INITIAL_STATE,
        isLoading: true,
      });

      try {
        const response = await cSharpApi.post(
          `charts/get-current-battery-charge/${deviceId}`,
          JSON.stringify(params),
          {
            cancelToken: cancelTokenSource.token,
          },
        );

        const data = await response.data.data;

        if (data) {
          setFetchedData({
            data,
            isLoading: false,
            hasError: false,
            errorMessage: "",
            message: response.data.message,
          });
        }
      } catch (error) {
        let errorMessage = "fetching data aborted";

        if (axios.isCancel(error)) {
          console.log("fetching data aborted");
        } else {
          errorMessage = error instanceof Error ? error.message : "Unknown error";
          console.log("An error occurred", error);
        }

        // @ts-expect-error
        setFetchedData({
          ...INITIAL_STATE,
          errorMessage,
        });
      }
      return () => cancelTokenSource.cancel();
    },
    [deviceId],
  );

  const { data, isLoading, hasError, errorMessage, message } = fetchedData;

  return { fetchData, data, isLoading, hasError, errorMessage, message };
};

export default useCurrentBatCharge;
